import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  continueShoppingButtonText: {
    id: 'checkout.cartPage.continueShoppingButton',
    defaultMessage: 'Continue Shopping',
    description: 'Text that is being displayed in the first cart step in back button',
  },
  proceedToCheckoutButtonText: {
    id: 'checkout.cartPage.proceedToCheckoutButton',
    defaultMessage: 'Proceed to checkout',
    description: 'Text that is being displayed in the first cart step in continue button',
  },
});
